// extracted by mini-css-extract-plugin
var _1 = "eiv4OZeVxdbSNIxO9H0X";
export { _1 as "icon" }
